import React, { useState } from 'react';
import { Button } from 'antd';
import { DocumentDownloadIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { useAppDispatch, useAppSelector } from 'store';

import { openAuthModal, setTicket } from 'modules/auth';
import { IMyResult } from 'modules/mavzuli-test';
import { useDownloadCertificate } from 'modules/private-universities';

import { ApplicationModal } from 'components';

interface IProps {
  myResults?: IMyResult;
  ticketId?: string;
}

const ResultFooter: React.FC<IProps> = ({ myResults, ticketId }) => {
  const t = useTranslations();
  const { mutate: downloadCertificate, isLoading: isDownloading } = useDownloadCertificate();
  const isRegistered = useAppSelector(state => state.user.phone);
  const dispatch = useAppDispatch();
  const [openApplicationCreate, setOpenApplicationCreate] = useState(false);

  const onDownload = (ticketId?: number) => {
    if (isRegistered) {
      downloadCertificate(ticketId);
    } else {
      dispatch(setTicket(ticketId));
      dispatch(openAuthModal())
    }
  };

  return (
    <>
      <div className="mt-5 flex items-center gap-3">
        {myResults?.can_generate_certificate && (
          <Button
            loading={isDownloading}
            onClick={() => onDownload(Number(ticketId))}
            className="!py-4.5 !w-full !rounded-md !border !font-medium !text-indigo-600 hover:!border-indigo-600"
          >
            <DocumentDownloadIcon />
            {t('sertifikatni_korish')}
          </Button>
        )}

        {!myResults?.application && (
          <Button
            onClick={() => setOpenApplicationCreate(true)}
            className="!w-full !rounded-lg !border-none !bg-green-500 !px-7 !py-5 !text-white hover:!border-none"
          >
            {t('ArizaQoldirish')}
          </Button>
        )}
      </div>
      <ApplicationModal
        ticketId={Number(ticketId)}
        open={openApplicationCreate}
        onClose={() => setOpenApplicationCreate(false)}
        score={myResults?.ball}
        passingScore={myResults?.direction?.passing_ball}
      />
    </>
  );
};

export default ResultFooter;
